import { useQuery } from "@tanstack/react-query";
import { CalendarCheck2, Medal, MessageSquareText } from "lucide-react";
import { api } from "@/services/api";

function formatDate(value) {
  if (!value) return "Em andamento";
  return new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }).format(new Date(value));
}

export default function History() {
  const { data: sessions = [], isLoading } = useQuery({ queryKey: ["sessions"], queryFn: api.getSessions });

  return (
    <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8" data-testid="history-page">
      <section className="page-title-row" data-testid="history-title-section">
        <p className="section-kicker" data-testid="history-page-kicker">progresso</p>
        <h1 className="font-display text-4xl font-black sm:text-5xl lg:text-6xl" data-testid="history-page-heading">Histórico de prática</h1>
        <p className="max-w-3xl text-base font-semibold text-slate-600 md:text-lg" data-testid="history-page-description">
          Veja pontuação, quantidade de falas e sessões finalizadas para acompanhar sua evolução.
        </p>
      </section>
      <section className="mt-8 space-y-4" data-testid="history-session-list">
        {isLoading && <div className="neo-card surface-neutral p-6" data-testid="history-loading-state">Carregando histórico...</div>}
        {!isLoading && sessions.length === 0 && (
          <div className="neo-card surface-yellow p-6" data-testid="history-empty-state">Nenhuma sessão ainda. Comece uma prática de 15 minutos hoje.</div>
        )}
        {sessions.map((session) => (
          <article className="neo-card surface-neutral p-5" key={session.id} data-testid={`history-session-card-${session.id}`}>
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
              <div>
                <p className="text-xs font-black uppercase text-slate-500" data-testid={`history-session-status-${session.id}`}>{session.status === "completed" ? "concluída" : "em andamento"}</p>
                <h2 className="mt-1 font-display text-2xl font-black" data-testid={`history-session-title-${session.id}`}>{session.scenario_title}</h2>
                <p className="mt-1 text-sm font-semibold text-slate-600" data-testid={`history-session-date-${session.id}`}>{formatDate(session.completed_at || session.started_at)}</p>
              </div>
              <div className="grid grid-cols-3 gap-3 text-center">
                <div className="mini-metric" data-testid={`history-session-score-${session.id}`}><Medal size={18} />{session.score}%</div>
                <div className="mini-metric" data-testid={`history-session-turns-${session.id}`}><MessageSquareText size={18} />{session.turns.length}</div>
                <div className="mini-metric" data-testid={`history-session-minutes-${session.id}`}><CalendarCheck2 size={18} />{session.minutes}m</div>
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}